import { PLAN_META, type Plan, type NewPlan } from "@workspace/plans";

export type PlanBadgeVariant = "admin" | "sidebar";

export interface PlanBadgeStyle {
  label: string;
  className: string;
  color: string;
  isLegacy: boolean;
}

const ADMIN_NEW_PLAN_STYLES: Record<NewPlan, { className: string; color: string }> = {
  free: {
    className: "bg-gray-700/50 text-gray-300 border border-gray-600/50",
    color: "#6b7280",
  },
  track: {
    className: "bg-blue-900/40 text-blue-300 border border-blue-700/50",
    color: "#3b82f6",
  },
  draft: {
    className: "bg-emerald-900/40 text-emerald-300 border border-emerald-700/50",
    color: "#10b981",
  },
  enterprise: {
    className: "bg-purple-900/40 text-purple-300 border border-purple-700/50",
    color: "#8b5cf6",
  },
};

const ADMIN_UNKNOWN_STYLE = {
  className: "bg-gray-700/50 text-gray-400 border border-gray-600/50",
  color: "#9ca3af",
};

const SIDEBAR_NEW_PLAN_STYLES: Record<NewPlan, { className: string; color: string }> = {
  free:       { className: "bg-white/10 text-white/70",                   color: "#9ca3af" },
  track:      { className: "bg-blue-500/20 text-blue-200",                color: "#3b82f6" },
  draft:      { className: "bg-emerald-500/20 text-emerald-200",          color: "#10b981" },
  enterprise: { className: "bg-purple-500/20 text-purple-200",            color: "#8b5cf6" },
};

const SIDEBAR_UNKNOWN_STYLE = {
  className: "bg-white/10 text-white/70",
  color: "#9ca3af",
};

export function getPlanLabel(plan: string | null | undefined): string {
  if (!plan) return "—";
  const meta = PLAN_META[plan as NewPlan];
  return meta ? meta.name : plan;
}

export function getPlanBadgeStyle(
  plan: string | null | undefined,
  variant: PlanBadgeVariant = "admin",
): PlanBadgeStyle {
  const label = getPlanLabel(plan);
  const newStyles = variant === "sidebar" ? SIDEBAR_NEW_PLAN_STYLES : ADMIN_NEW_PLAN_STYLES;
  const unknownStyle = variant === "sidebar" ? SIDEBAR_UNKNOWN_STYLE : ADMIN_UNKNOWN_STYLE;

  if (!plan) {
    return { label, ...unknownStyle, isLegacy: false };
  }
  const meta = PLAN_META[plan as NewPlan];
  if (!meta) {
    return { label, ...unknownStyle, isLegacy: false };
  }
  const style = newStyles[meta.key];
  return { label, className: style.className, color: style.color, isLegacy: false };
}

export const PLAN_FILTER_OPTIONS: { value: string; label: string }[] = [
  ...Object.values(PLAN_META).map((m) => ({ value: m.key, label: m.name })),
];

export type AnyPlan = Plan;
